// @ts-nocheck
import {
  AdminReservedMember,
  ReservedMembersType,
  ReservedPersonalSchedule
} from '#types/schedule';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import useScheduleRegistrationUrl from '../../hooks/useScheduleRegistrationUrl';
import { TimelineColumns } from '../../types';
import { TimeObj, generateTimeBlocks, getIdByDate } from '../../utils';
import LectureScheduleSlot from '../LectureScheduleSlot';
import PersonalScheduleSlot from '../PersonalScheduleSlot';
import TimeLabelsCol from '../TimeLabelsCol';
import * as S from './styles';
import TagManager from 'react-gtm-module';

interface Props {
  columns: TimelineColumns[];
  activeDate: Date | dayjs.Dayjs | string;
  onClickSchedule?: (
    data: ReservedMembersType | AdminReservedMember | ReservedPersonalSchedule
  ) => void;
}

export default function Timeline({ columns, onClickSchedule }: Props) {
  const navigate = useNavigate();
  const times = generateTimeBlocks();
  const scheduleRegistrationUrl = useScheduleRegistrationUrl();

  const handleClick = (data: ReservedMembersType | AdminReservedMember) => {
    if (onClickSchedule) {
      onClickSchedule(data);
    }
  };

  const handleClickBlock = (day: dayjs.Dayjs, time: TimeObj) => {
    const dateParams = dayjs(day)
      .set('hour', time.hours)
      .set('minute', time.minutes);

    TagManager.dataLayer({
      dataLayer: {
        event: 'calendertab_emptycell_click',
        category: '일정관리',
        action: 'calendertab_emptycell_click',
        value: 1
      }
    });
    navigate(
      `${scheduleRegistrationUrl}&date=${encodeURIComponent(
        dateParams.format('YYYY-MM-DD HH:mm')
      )}`
    );
  };

  return (
    <S.Container>
      <S.CalendarContainer>
        <TimeLabelsCol />
        {columns.map((col, index) => (
          <S.Col key={index} columnWidth={col.width}>
            <>
              {times.map((time, timeIndex) => {
                const key = getIdByDate(
                  dayjs(col.date)
                    .set('hour', time.hours)
                    .set('minute', time.minutes)
                );

                const currentObj = columns[index].data?.find(item => {
                  let dataId;

                  if (item.isPersonalSchedule) {
                    dataId = getIdByDate(
                      (item as ReservedPersonalSchedule).startAt
                    );
                  } else {
                    dataId = getIdByDate(item.taughtAt);
                  }

                  return dataId === key;
                });

                const isExistSchedule =
                  columns[index].data?.length > 0 && currentObj;

                return (
                  <S.ColBlock
                    key={timeIndex}
                    isHalf={time.minutes !== 0}
                    isExistSchedule={!!isExistSchedule}
                    onClick={() => {
                      if (!col.isNotClickable) {
                        handleClickBlock(col.date, time);
                      }
                    }}
                  >
                    {isExistSchedule && (
                      <>
                        {currentObj?.isPersonalSchedule ? (
                          <PersonalScheduleSlot
                            startAt={
                              (currentObj as ReservedPersonalSchedule).startAt
                            }
                            endAt={
                              (currentObj as ReservedPersonalSchedule).endAt
                            }
                            title={
                              (currentObj as ReservedPersonalSchedule).title
                            }
                            onClick={e => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleClick(
                                currentObj as ReservedPersonalSchedule
                              );
                            }}
                          />
                        ) : (
                          <LectureScheduleSlot
                            taughtAt={currentObj.taughtAt}
                            endedAt={currentObj.endedAt}
                            round={currentObj.round}
                            totalRound={currentObj.totalRound}
                            personId={currentObj.personId}
                            personName={currentObj.personName}
                            isGroup={currentObj.isGroup}
                            onClick={e => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleClick(currentObj);
                            }}
                          />
                        )}
                      </>
                    )}
                  </S.ColBlock>
                );
              })}
            </>
          </S.Col>
        ))}
      </S.CalendarContainer>
    </S.Container>
  );
}
